import React, { useCallback, useEffect, useState } from "react";
import { ClockCounterClockwise } from "@phosphor-icons/react";
import { fetchStats } from "@/lib/history";
import { LOCALES, useI18n } from "@/lib/i18n";

/** Etiquetas impresas hoy y esta semana, siempre visibles en la barra. Clic abre el historial. */
export default function LabelCounter({ onOpen }) {
    const { t, lang } = useI18n();
    const [stats, setStats] = useState(null);

    const refresh = useCallback(async () => {
        try {
            setStats(await fetchStats());
        } catch {
            /* sin datos: se reintenta en el próximo ciclo */
        }
    }, []);

    useEffect(() => {
        refresh();
        const id = setInterval(refresh, 60000);
        window.addEventListener("zebralab:printed", refresh);
        return () => {
            clearInterval(id);
            window.removeEventListener("zebralab:printed", refresh);
        };
    }, [refresh]);

    const fmt = (n) => (n ?? 0).toLocaleString(LOCALES[lang]);
    const today = fmt(stats?.today?.labels);
    const week = fmt(stats?.week?.labels);
    return (
        <button
            data-testid="label-counter"
            onClick={onOpen}
            title={t("counter.title", { today, week, month: fmt(stats?.month?.labels) })}
            className="flex items-center gap-2 px-2.5 py-1.5 text-xs bg-white border border-brand-300 text-brand-900 hover:bg-brand-100 font-medium"
            translate="no"
        >
            <ClockCounterClockwise size={14} />
            <span className="font-mono" data-testid="label-counter-text">
                {`${t("counter.today")} ${today} · ${t("counter.week")} ${week}`}
            </span>
        </button>
    );
}
